import { FC } from "react"

export const IDOProgramDescribe: FC = () => (
  <p className={"text-base leading-6 font-normal text-gray-200"}>
    Raised through hybrid On-chain/Off-chain lottery
  </p>
)
